import type { CSSProperties, HTMLAttributes } from 'react';

import { cn } from '@/shared/lib/cn';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  testID?: string;
}

export function Skeleton({
  className,
  width,
  height,
  circle,
  style,
  testID,
  ...props
}: SkeletonProps) {
  const inline: CSSProperties = {
    ...style,
    width: width ?? style?.width,
    height: height ?? style?.height,
  };
  return (
    <div
      role="status"
      aria-label="Carregando..."
      data-testid={testID}
      style={inline}
      className={cn(
        'animate-pulse bg-surface-high',
        circle ? 'rounded-pill' : 'rounded-base',
        className,
      )}
      {...props}
    />
  );
}
